// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","container":"_13GVHKkIYPxevVP0Jrr1LP _15-uIrn7gODHiOpUuDWjwC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-index/ProductIndex.css
// module id = 1068
// module chunks = 1